import { getReasonList } from '../services/commonService'

import types from './types'

const { FETCH_REASON_LIST } = types

function fetchReasonList() {
  return dispatch =>
    getReasonList().then(response => {
      dispatch({
        type: FETCH_REASON_LIST,
        state: response
      })
      return response
    })
}

export default fetchReasonList



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchBlockIdentifier.js